<template>
  <div id="container">

    <div class="contact" id="contact">
      <div id="sec">
        <div class="contact_details">
          <div class="details">
            <h2>Send us a message and we will get back to you between 24 hours </h2>
            <br>
            <br>

            <div class="call">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                   width="34" height="24"
                   viewBox="0 0 172 172"
                   style=" fill:#ffffff;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                   stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                   font-family="none" font-weight="none" font-size="none" text-anchor="none"
                   style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="#ffffff">
                    <path d="M141.56266,11.40788c-2.58694,-0.04565 -4.83938,1.75806 -5.3603,4.29242c-0.52092,2.53436 0.83748,5.08026 3.2327,6.05866c3.97124,1.69046 7.71883,3.6724 11.07894,5.96989c1.5849,1.10801 3.64279,1.27934 5.38909,0.44867c1.7463,-0.83067 2.91185,
                   -2.5353 3.05227,-4.46399c0.14042,-1.92869 -0.76593,-3.78417 -2.37349,-4.85903c-4.05022,-2.76935 -8.4195,-5.06316 -12.93359,-6.9847c-0.6573,-0.29194 -1.36651,-0.44902 -2.08561,-0.46191zM86,21.486c-28.28683,0 -52.14629,6.09822 -63.83512,16.29997c-6.06658,5.29617 -8.86802,13.02357 -7.49561,20.68115l1.16178,4.08724c1.96367,8.03025 9.9148,13.46124 18.52555,12.59766l9.09831,-1.14079c7.30642,-0.7095 13.31348,-5.78137 14.87223,-12.3317l2.50553,-11.11393c0.18275,-0.76325 0.69433,-1.4569 1.37874,-1.85465c2.0425,-1.09292 13.60474,-2.1276 23.78857,-2.1276c10.18383,0 21.74266,1.03469 23.78158,2.1276c0.68083,0.39775 1.20098,1.0881 1.46973,2.1416l2.33057,10.53304c1.64475,6.84417 7.65573,11.91291 14.85823,12.61166l9.30127,1.16878c0.58408,0.05734 1.16576,0.08399 1.74268,0.08399c7.85467,0 14.84766,-5.20983 16.6429,-12.55566l1.11279,-3.87028l0.08399,-0.34994c1.37242,-7.65758 -1.42902,-15.39198 -7.49561,-20.68815c-11.68167,-10.20533 -35.54129,-16.29997 -63.82812,-16.29997zM73.37435,60.83968c-2.96578,0.04633 -5.33356,2.48614 -5.29101,5.45198v9.22428l-12.78662,6.38981c-18.63692,9.32025 -30.21338,28.04882 -30.21338,48.8859c0,10.86825 8.84008,19.70833 19.70833,19.70833h82.41667c10.86825,0 19.70833,-8.84008 19.70833,-19.70833c0,-20.83708 -11.57646,-39.56565 -30.21338,-48.8859l-12.78662,-6.38981v-9.22428c0.02741,-1.93842 -0.99102,-3.74144 -2.66532,-4.71865c-1.6743,-0.97721 -3.74507,-0.97721 -5.41937,0c-1.6743,0.97721 -2.69273,2.78023 -2.66532,4.71865v5.375h-14.33333v-5.375c0.02085,-1.45347 -0.54782,-2.85342 -1.57635,-3.88062c-1.02852,-1.0272 -2.4292,-1.59408 -3.88264,-1.57136zM13.9834,81.34587c-2.28691,0.11838 -4.24775,1.67256 -4.88519,3.87202c-0.63743,2.19946 0.1885,4.56128 2.05771,5.88416c4.30351,3.15064 9.26562,5.40967 14.57829,6.56478c1.90739,0.49209 3.93117,-0.09849 5.27452,-1.53923c1.34335,-1.44074 1.79107,-3.50084 1.1669,-5.36918c-0.62417,-1.86834 -2.22026,-3.24565 -4.15984,-3.58963c-3.81767,-0.83006 -7.39822,-2.47059 -10.50505,-4.74512c-0.86481,-0.65214 -1.90646,-1.02781 -2.98844,-1.0778c-0.17952,-0.00901 -0.35938,-0.00901 -0.5389,0zM66.29167,100.33333c2.967,0 5.375,2.408 5.375,5.375c0,2.967 -2.408,5.375 -5.375,5.375c-2.967,0 -5.375,-2.408
                   -5.375,-5.375c0,-2.967 2.408,-5.375 5.375,-5.375zM86,100.33333c2.967,0 5.375,2.408 5.375,5.375c0,2.967 -2.408,5.375 -5.375,5.375c-2.967,0 -5.375,-2.408 -5.375,-5.375c0,-2.967 2.408,-5.375 5.375,-5.375zM105.70833,100.33333c2.967,0 5.375,2.408 5.375,5.375c0,2.967 -2.408,5.375 -5.375,5.375c-2.967,0 -5.375,-2.408 -5.375,-5.375c0,-2.967 2.408,-5.375 5.375,-5.375zM66.29167,118.25c2.967,
                   0 5.375,2.408 5.375,5.375c0,2.967 -2.408,5.375 -5.375,5.375c-2.967,0 -5.375,-2.408 -5.375,-5.375c0,-2.967 2.408,-5.375 5.375,-5.375zM86,118.25c2.967,0 5.375,2.408 5.375,5.375c0,2.967 -2.408,5.375 -5.375,5.375c-2.967,0 -5.375,-2.408 -5.375,-5.375c0,-2.967 2.408,-5.375 5.375,-5.375zM105.70833,118.25c2.967,0 5.375,2.408 5.375,5.375c0,2.967 -2.408,5.375 -5.375,5.375c-2.967,0 -5.375,-2.408 -5.375,-5.375c0,-2.967 2.408,-5.375 5.375,-5.375z"></path>
                  </g>
                </g>
              </svg>
            1(833)564-6332 (EXT 0)
            </div>
            <br>
            <br>

            <div class="email">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                   width="34" height="24"
                   viewBox="0 0 172 172"
                   style=" fill:#ffffff;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                   stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                   font-family="none" font-weight="none" font-size="none" text-anchor="none"
                   style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g>
                    <path
                        d="M149.14192,18.1245l-128.64167,44.00692c-2.67675,0.91375 -3.46508,4.31792 -1.46558,6.31742l84.51292,84.51292c1.9995,1.9995 5.40367,1.21117 6.31742,-1.46558l44.00692,-128.64167c1.00692,-2.92758 -1.79883,-5.73333 -4.73,-4.73z"
                        fill="#ffffff"></path>
                    <path
                        d="M61.29292,110.70708l42.25467,42.25467c1.9995,1.9995 5.40367,1.21117 6.31742,-1.46558l44.00692,-128.64167c0.50525,-1.462 0.05375,-2.89533 -0.88867,-3.83775z"
                        fill="#ffffff"></path>
                    <path
                        d="M136.16667,35.83333l-89.58333,60.16058v25.83942c0,1.978 1.60533,3.58333 3.58333,3.58333h25.83942z"
                        fill="#ecf0f1"></path>
                  </g>
                </g>
              </svg>
              infoo@ourmail.com
            </div>
            <br>
            <br>

            <div class="address">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                   width="34" height="24"
                   viewBox="0 0 172 172"
                   style=" fill:#ffffff;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                   stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                   font-family="none" font-weight="none" font-size="none" text-anchor="none"
                   style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="#ffffff">
                    <path
                        d="M86,0c-21.91346,0 -39.69231,17.77885 -39.69231,39.69231c0,21.91346 34.52404,76.36118 34.52404,105.84615h10.33654c0,-29.38161 34.52404,-85.71574 34.52404,-105.84615c0,-21.91346 -17.77885,-39.69231 -39.69231,-39.69231zM86,19.84615c10.95673,0 19.84615,8.88942 19.84615,19.84615c0,10.95673 -8.88942,19.84615 -19.84615,19.84615c-10.95673,0 -19.84615,-8.88942 -19.84615,-19.84615c0,-10.95673 8.88942,-19.84615 19.84615,-19.84615zM45.27404,114.32212c-0.12921,0.05169 -0.28426,0.12921 -0.41346,0.20673c-12.19712,2.14483 -22.55949,5.09074 -30.38942,9.09615c-3.92788,2.01563 -7.3131,4.39303 -9.92308,7.23558c-2.60997,2.84255 -4.54808,6.56371 -4.54808,10.75c0,6.27945 4.16046,11.16346 9.09615,14.67788c4.9357,3.51442 11.1893,6.17608 18.8125,8.47596c15.2464,4.57392 35.63522,7.23558 58.09135,7.23558c22.45613,0 42.84496,-2.66166 58.09135,-7.23558c7.6232,-2.29988 13.8768,-4.96154 18.8125,-8.47596c4.9357,-3.51442 9.09615,-8.39844 9.09615,-14.67788c0,-4.18629 -1.91226,-8.08834 -4.54808,-10.95673c-2.63581,-2.86839 -5.99519,-5.01322 -9.92308,-7.02885c-7.88161,-4.00541 -18.32151,-6.95132 -30.59615,-9.09615c-2.3774,-0.51683 -4.83233,0.3101 -6.40865,2.14483c-1.60216,1.86058 -2.04147,4.41887 -1.1887,6.66706c0.8786,2.27404 2.92007,3.90204 5.32331,4.21214c11.39603,1.98978 20.87981,4.80649 26.875,7.85577c2.9976,1.52464 5.11659,3.15265 6.20192,4.34135c1.08534,1.18871 1.03365,1.65385 1.03365,1.86058c0,0.3101 -0.41346,1.73137 -3.51442,3.92788c-3.10096,2.19651 -8.34676,4.59976 -15.09135,6.61538c-13.48918,4.03125 -32.79267,6.61538 -54.16346,6.61538c-21.37079,0 -40.67428,-2.58413 -54.16346,-6.61538c-6.74459,-2.01562 -11.99038,-4.41887 -15.09135,-6.61538c-3.10096,-2.19651 -3.51442,-3.61779 -3.51442,-3.92788c0,-0.20673 -0.05168,-0.67187 1.03365,-1.86058c1.08534,-1.1887 3.23017,-2.81671 6.20192,-4.34135c5.96935,-3.04928 15.32392,-5.86599 26.66827,-7.85577c3.64363,-0.51683 6.20192,-3.90204 5.6851,-7.54567c-0.51683,-3.64363 -3.90204,-6.20192 -7.54567,-5.6851z"></path>
                  </g>
                </g>
              </svg>
              London ON
            </div>
            <div class="socials">
              <ul>
                <li>
                  <a href="https://www.instagram.com/diversified.dementia/" target="_blank"><img
                      src="https://img.icons8.com/fluent/28/ffffff/instagram-new.png" alt="instagram"/></a>
                </li>
                <li>
                  <a href="https://www.facebook.com/Diversified-Dementia-Care-107213841327774/" target="_blank"> <img
                      src="https://img.icons8.com/fluent/28/ffffff/facebook-new.png" alt="facebook"/>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/diversified-dementia-care-service/" target="_blank"><img
                      src="https://img.icons8.com/fluent/28/000000/linkedin.png" alt="linkedin"/>
                  </a>
                </li>

              </ul>
            </div>
          </div>
        </div>
        <div class="form_section">
          <iframe src="https://www.cognitoforms.com/f/XgneZ0-g00OXljwZXvzjrA?id=1"
                  style="position:relative;width:1px;min-width:100%;*width:100%;" frameborder="0" scrolling="yes"
                  seamless="seamless" height="755" width="100%"></iframe>

        </div>


      </div>
      <div class="book_us">
        <h2>Booking</h2>
        <iframe src="https://dementiadementia-developer.youcanbook.me/?noframe=true&skipHeaderFooter=true"
                id="ycbmiframedementiadementia-developer"
                style="width:100%;height:1000px;border:0px;background-color:transparent;" frameborder="0"
                allowtransparency="true"></iframe>


      </div>
    </div>

    <div class="hiring">
      <p>
        <router-link :to="{name: 'Joinus'}" class="join_us" exact>We are hiring</router-link>
      </p>
    </div>


  </div>

</template>

<script>

export default {
  name: "Contact",
  components: {},
  data() {
    return {

      title: "Contact"

    }
  },
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://sprintful.com/widget/v1.js' //sprintful
    // script.src = 'https://cdn.oncehub.com/mergedjs/so.js' //schedule once
    script.addEventListener('load', this.setLoaded);
    document.body.appendChild(script);
  },

}

</script>


<style lang="scss" scoped>
@import "./src/assets/Colors/colors";
@import "./src/assets/Fonts/fonts";
@import "./src/assets/Buttons/buttons";
@import url('https://fonts.googleapis.com/css2?family=Rozha+One&display=swap');

#container {

  .hiring {
    p {
      margin: 30px auto;
      text-align: center;
      position: relative;
      width: 10%;
      padding: 8px;
      border-radius: 6rem;
      background: #57606f;

      cursor: pointer;

      a {
        text-decoration: none;
        color: $textColor;
      }


      &:hover {
        background: $headerColor;
        color: $textColor;
      }
    }

  }

  .contact {
    margin: 0 auto !important;
    padding: 10px;
    outline: none !important;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    #sec {
      width: 80%;
      margin: 25vh auto;
      border-radius: 2rem;
      box-shadow: 0 5px 10px rgba(154, 160, 185, .05), 0 15px 40px rgba(166, 173, 201, .2);
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      .form_section {
        padding: 40px;
        text-align: center !important;
        border-radius: 2rem;
        grid-column-start: 2;
        grid-column-end: 4;
      }

      .contact_details {
        background: $highlight;
        padding: 40px;
        box-shadow: 0 5px 10px rgba(154, 160, 185, .05), 0 15px 40px rgba(166, 173, 201, .2);
        color: $textColor;
        border-radius: 2rem;
        font-weight: bolder;

        .details {
          margin-top: 10vh;
        }

        h2 {
          margin: 10px;
          font-size: 18px;
        }
      }

      .socials {
        margin-top: 5vh;

        ul {
          li {
            list-style: none;
            display: inline-block;
            margin: 20px;

            img {
              border-radius: 10%;
              padding: 10px;
              box-shadow: 0 5px 10px rgba(154, 160, 185, .05), 0 15px 40px rgba(166, 173, 201, .2);
              cursor: pointer;
              background: lighten($highlight, 23%);
            }
          }
        }
      }
    }
    .book_us{
      h2{
        text-align: center;
        margin: 30px;
        font-size:40px;
      }
    }
  }
}


@media (max-width: 599px) and (-webkit-min-device-pixel-ratio: 2) {
  #container {

    .landing {
      display: none;
    }

    .contact {
      padding: 0;

      #sec {
        display: unset;
        width: 100%;
        background: white;
        margin: 8vh auto 5vh;
        .contact_details {
          border-radius: 0px;
          margin: 0 auto;
          width: 100%;
          padding: 12px;
        }

        .form_section {
          padding: 0;

        }
      }


    }

    .hiring {
      p {
        width: 53%;
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
  #container {

    .landing {
      display: none;
    }

    .contact {
      padding: 0;

      #sec {
        display: unset;
        width: 100%;
        background: white;

        .contact_details {
          border-radius: 0px;
          margin: 5vh auto;
          width: 98%;
          padding: 12px;

        }

        .form_section {
          width: 90%;
          padding: 20px;

        }
      }


    }

    .hiring {
      p {
        width: 53%;
      }
    }
  }
}
</style>